import * as React from 'react';
import './Profile.scss';

import Toast from 'components/Toast';
import Loader from 'components/Loader';

import { UserService } from 'services/ApiService';

import { User, ToastState, UserType } from 'types';

export default class Profile extends React.Component<{}, {
  user: User | null,
  loading: boolean,
  changingPwd: boolean
}> {
  formRefs: {
    oldPwd: HTMLInputElement | null,
    pwd: HTMLInputElement | null,
    confirmPwd: HTMLInputElement | null
  } = {
    oldPwd: null,
    pwd: null,
    confirmPwd: null
  };

  constructor(props: {}) {
    super(props);
    this.state = {
      user: null,
      loading: false,
      changingPwd: false
    };
  }

  reload = () => {
    this.setState({ loading: true }, () => {
      UserService.fetch().then(user => {
        this.setState({ loading: false, user });
      }).catch(err => {
        this.setState({ loading: false });
      });
    });
  }

  updatePwd = (e: React.FormEvent<HTMLFormElement>, email: string) => {
    e.preventDefault();
    if (this.formRefs.oldPwd && this.formRefs.oldPwd.value.toString()) {      
      UserService.login({ email, password: this.formRefs.oldPwd.value.toString() }).then((data) => {
        if (this.formRefs.pwd!!.value === this.formRefs.confirmPwd!!.value
          && this.state.user
          && this.formRefs.pwd
          && this.formRefs.pwd.value) {
          UserService.update(
            {
              ...this.state.user,
              password: this.formRefs.pwd.value.toString()
            }
          ).then((user) => {
            this.setState({ changingPwd: false, loading: false });
            Toast.present({ message: 'Password updated successfully!' }, ToastState.SUCCESS);
          }).catch(err => {
            this.setState({ loading: false });
          });
        } else {
          Toast.throw({ message: 'Your passwords do not match & must not be empty!' });
        }
      }).catch((err) => {
        this.setState({ loading: false });
      });
    } else {
      Toast.throw({ message: 'Current password required.' });
    }      
  }

  cancelUpdatePwd = () => {
    this.setState({ changingPwd: false });
  }

  componentDidMount() {
    this.reload();
  }

  render() {
    const { loading, user, changingPwd } = this.state;
    var userType = 'LCBO Employee';
    if (user && user.type === UserType.Admin) {
      userType = 'LCBO Manager';
    } else if (user && user.type === UserType.LCBOReporter) {
      userType = 'LCBO Reporter';
    } else if (user && user.type === UserType.QAAdmin) {
      userType = 'QA Admin';
    }

    return (
      <div className="container">
        <div className="header" />
        {
          loading || !user ? <div className="loaderIcon"><Loader /></div> :
            <>
              <img src={require('./profileIcon.png')} alt="Profile" className="profileIcon"/>
              <div className="profileContent">
                <div className="userType">{userType}</div>
                <div className="userName">{user.contactName}</div>
                <div className="email">
                  <span>
                    {user.email}
                  </span>
                </div>
                {changingPwd ?
                  <div className="form">
                    <form onSubmit={(e) => this.updatePwd(e, user.email)}>
                      <div className="oldPwd">
                        <input
                            type="password"
                            ref={el => this.formRefs.oldPwd = el}
                            placeholder="Old Password"
                        />
                      </div>
                      <div className="newPwd">
                        <input
                          type="password"
                          ref={el => this.formRefs.pwd = el}
                          placeholder="New Password"
                        />
                      </div>
                      <div className="confirmPwd">
                        <input
                          type="password"
                          ref={el => this.formRefs.confirmPwd = el}
                          placeholder="Confirm New Password"
                        />
                      </div>                      
                      <button
                        className="cancelBtn"
                        onClick={this.cancelUpdatePwd}
                      >
                        Cancel
                      </button>
                      <button className="saveBtn">Save</button>
                    </form>
                  </div> :
                  <button
                    className="changePwdBtn"
                    onClick={() => {
                      this.setState({ changingPwd: true });
                    }}
                  >
                    Change Password
                  </button>
                }
              </div>
            </>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Profile/index.tsx